enum ProblemTrackerFilter {
  OutOfRange = 'OutOfRange',
  OutOfSpecification = 'OutOfSpecification',
  OutOfTime = 'OutOfTime',
}

export default ProblemTrackerFilter;
